/**
 * Options used to control default behaviors regarding compatibility support
 */
var CompatibilityOptions = /** @class */ (function () {
    function CompatibilityOptions() {
    }
    /**
     * Defines if the system should use OpenGL convention for UVs when creating geometry or loading .babylon files (false by default)
     */
    CompatibilityOptions.UseOpenGLOrientationForUV = false;
    return CompatibilityOptions;
}());
export { CompatibilityOptions };
//# sourceMappingURL=compatibilityOptions.js.map